import axios from '@axios'

const PREFIX = '/procedimentos'

export default {
  source: null,
  CancelToken: null,

  saveProcedimento(procedimento, tokenCancel) {
    this.source = tokenCancel.source()
    this.CancelToken = tokenCancel

    return axios.post(`${PREFIX}`, procedimento, { cancelToken: this.source.token })
  },

  getURLProcedimento(nomeRecurso) {
    return axios.get(`${PREFIX}/${nomeRecurso}`)
  },

  deleteProcedimento(nomeRecurso) {
    return axios.delete(`${PREFIX}/${nomeRecurso}`)
  },

  abortarUpload() {
    this.source.cancel()
  },
}
